// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
/* eslint-disable filename-export/match-default-export */
/* disabling rule until refactor of analytics builder */

import React from 'react';
import propTypes from 'prop-types';

import { MrInputRadio, MrInputRadioGroup } from '@ion/components';
import { Typography, Link } from '@metarouter-private/mr-mui';

const RADIO_GROUP_LABEL = fileNameText => `How would you like to host your ${fileNameText} file?`;

export const HOSTING_TYPES = {
  self: 'SELF',
  metaRouter: 'META_ROUTER',
};

const HOSTING_TYPE_VALUES = Object.values(HOSTING_TYPES);

export const READABLE_HOSTING_TYPE = {
  [HOSTING_TYPES.self]: 'Manual Deployment',
  [HOSTING_TYPES.metaRouter]: 'Auto-deploy to Cluster',
};

const metarouterHostingSecondaryLabel = (
  <Typography variant="body2">
    Automate your file deployments by following our{' '}
    <Link
      href="https://docs.metarouter.io/docs/deploying-your-ajs-tracking-file#metarouter-hosted-deployment"
      underline="always"
      variant="body2"
      target="_blank"
      rel="noopener"
      color="secondary"
    >
      auto-deployment documentation.
    </Link>
  </Typography>
);

const selfHostingSecondaryLabel = (
  <Typography variant="body2">
    Download your tracking file to manually deploy it.{' '}
    <Link
      href="https://docs.metarouter.io/docs/deploying-your-ajs-tracking-file#self-hosted-deployment"
      underline="always"
      variant="body2"
      target="_blank"
      rel="noopener"
      color="secondary"
    >
      See documentation.
    </Link>
    .
  </Typography>
);

export default function AnalyticsBuilderFileHosting({ value = '', onChange, resetError, errorMsg, fileNameText }) {
  return (
    <MrInputRadioGroup
      name="fileHostingType"
      label={RADIO_GROUP_LABEL(fileNameText)}
      overrideValue={value}
      onChange={onChange}
      errorMsg={errorMsg}
      resetError={resetError}
      required
    >
      <MrInputRadio
        value={HOSTING_TYPES.self}
        label={READABLE_HOSTING_TYPE[HOSTING_TYPES.self]}
        secondaryLabel={selfHostingSecondaryLabel}
      />
      <MrInputRadio
        value={HOSTING_TYPES.metaRouter}
        label={READABLE_HOSTING_TYPE[HOSTING_TYPES.metaRouter]}
        secondaryLabel={metarouterHostingSecondaryLabel}
      />
    </MrInputRadioGroup>
  );
}

AnalyticsBuilderFileHosting.propTypes = {
  value: propTypes.oneOf([...HOSTING_TYPE_VALUES, '']),
  onChange: propTypes.func.isRequired,
  resetError: propTypes.func.isRequired,
  errorMsg: propTypes.string,
  fileNameText: propTypes.string,
};
